import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ServiceDTO } from '@core/apis/service/service.dto';
import { DatepickerInputComponent } from '@core/components/datepicker-input/datepicker-input.component';
import { BookingStorageEnum } from '@core/enums/booking.enum';
import { IBookingBasketItem, IBookingStorageDeleteEvent, IFormatTimeData } from '@core/interfaces/booking.interface';
import { IUserStore } from '@core/interfaces/interface';
import { UserStore } from '@core/stores/user.store';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ServiceViewComponent } from '../../service-view/service-view.component';
import { FormatTimeDataTypeEnum } from '@oranta-mis/sdk';

@Component({
  selector: 'app-service-order',
  imports: [TranslocoModule, ReactiveFormsModule, ServiceViewComponent, DatepickerInputComponent],
  standalone: true,
  templateUrl: './service-order.component.html',
  styleUrl: './service-order.component.scss',
})
@UntilDestroy()
export class ServiceOrderComponent {
  public program!: ServiceDTO;
  public form!: FormGroup;
  public user: IUserStore | null = null;
  public durationType!: FormatTimeDataTypeEnum;
  public readonly FormatTimeDataTypeEnum = FormatTimeDataTypeEnum;

  @Input() set programValue(p: ServiceDTO) {
    if (p) {
      this.program = p;
    }
  }
  @Output() delete: EventEmitter<IBookingStorageDeleteEvent> = new EventEmitter<IBookingStorageDeleteEvent>();
  @Output() formValue: EventEmitter<IBookingBasketItem> = new EventEmitter<IBookingBasketItem>();

  constructor(
    private readonly userStore: UserStore,
    private readonly fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.user = this.userStore.get();
    this.reactiveForm();
    this.form.get('patientId')?.setValue(this.userStore.get()?.id);
    this.formValue.emit({
      type: BookingStorageEnum.service,
      form: this.form,
    });
    this.form.valueChanges.pipe(untilDestroyed(this)).subscribe((v) => {
      this.formValue.emit({
        type: BookingStorageEnum.service,
        form: this.form,
      });
    });
    this.form.get('id')?.setValue(this.program.id);
    let value: IFormatTimeData = this.program.formatTime;
    if (value) {
      this.durationType = value.type;
      if (this.durationType == FormatTimeDataTypeEnum.by_date) this.startDate?.setValue(value.startDate);
    }
  }

  private reactiveForm() {
    this.form = this.fb.group({
      id: [null, Validators.required],
      startDate: [null, Validators.required],
      note: [null],
      patientId: [null, Validators.required],
    });
  }

  public get startDate(): FormControl {
    return this.form.get('startDate') as FormControl;
  }
}
